
import { defineComponent, ref, watch, nextTick } from "vue";
import vModal from "@/components/vModal.vue";
import confetti from "canvas-confetti";

export default defineComponent({
  name: "vTrialLabelCongratulationsModal",
  components: {
    vModal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close-modal"],
  setup(props, { emit }) {
    const confettiCanvas = ref<HTMLCanvasElement | null>(null);

    const fireConfetti = () => {
      const canvas = confettiCanvas.value;
      if (!canvas) return;

      const fire = confetti.create(canvas, { resize: true, useWorker: true });
      const end = Date.now() + 3000;

      const shootBurst = () => {
        fire({
          particleCount: 6,
          angle: 60,
          spread: 55,
          origin: { x: 0, y: 0.65 },
          colors: ["#558b2f", "#ef6c00", "#fdd835", "#1e88e5", "#e53935"],
        });
        fire({
          particleCount: 6,
          angle: 120,
          spread: 55,
          origin: { x: 1, y: 0.65 },
          colors: ["#558b2f", "#ef6c00", "#fdd835", "#1e88e5", "#e53935"],
        });

        if (Date.now() < end) {
          requestAnimationFrame(shootBurst);
        }
      };

      shootBurst();
    };

    const closeModal = () => {
      emit("close-modal");
    };

    watch(
      () => props.showModal,
      (val) => {
        if (val) {
          nextTick(() => fireConfetti());
        }
      }
    );

    return {
      confettiCanvas,
      closeModal,
    };
  },
});
